module.exports = __webpack_public_path__ + "static/media/koala.62a21b74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/primary-interface/koala.svg
// module id = 621
// module chunks = 6